import React from 'react'
import "./Policy_banner.css"
import Breadcrumb_comp from '../breadcrumb-comp/Breadcrumb_comp'

function Policy_banner({ breadcrumbs ,headingText,imgSrc}) {
    return (
        <>
            <section className='Policy_banner'>
                <Breadcrumb_comp
                    breadcrumbs={breadcrumbs}
                />

                <div className="img_holder">
                    <img className="banner_img"
                        src={
                            process.env.PUBLIC_URL +
                            imgSrc
                            
                        }
                        alt="Banner img"
                    />
                </div>


                <div className='heading_holder'>
                    <h1>{headingText}</h1>
                </div>
            </section>
        </>
    )
}

export default Policy_banner